import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useUserStore = defineStore('user', () => {
    const userLevel = ref<number | null>(null)

    const setUserLevel = (level: number | null) => {
        userLevel.value = level
    }

    return { userLevel, setUserLevel }
})
